var path = 'components/side-menu.tpl.html';
var html = " <ul flex layout=column layout-align=\"start stretch\" class=tk-side-menu> <li ng-repeat=\"section in sections\" class=parent-list-item ng-class=\"{'parentActive' : isOpen(section)}\"> <tk-menu-link section=section></tk-menu-link> </li> </ul>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/side-menu.tpl.html
// module id = 1487
// module chunks = 1